import secureApi from "../utils/secureApi";
import configService from "../services/configService";

export interface PresignedUpload {
  presignedUrl: string;
  key: string;
}

const unwrap = <T,>(response: any): T => (response?.data ?? response) as T;

export async function uploadFile(
  file: File,
  context: string
): Promise<PresignedUpload> {
  const extension = file.name.split(".").pop() || "bin";
  const fileName = `${Date.now()}.${extension}`;
  const upload = unwrap<PresignedUpload>(
    await secureApi.post("/api/v1/general/presigned-url", {
      fileName,
      contentType: file.type || "application/octet-stream",
      context,
    })
  );

  if (!upload.presignedUrl || !upload.key) {
    throw new Error("The upload service did not return a presigned URL.");
  }

  const result = await fetch(upload.presignedUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type || "application/octet-stream" },
    body: file,
  });

  if (!result.ok) {
    throw new Error("File upload failed.");
  }

  return upload;
}

export async function deleteUploadedFile(fileKey: string, context: string): Promise<void> {
  await secureApi.post("/api/v1/general/delete-file", { fileKey, context });
}

export const toCdnUrl = (key: string, cdnBaseUrl = configService.getCdnBaseUrl()) =>
  key.startsWith("http") ? key : cdnBaseUrl ? `${cdnBaseUrl.replace(/\/$/, "")}/${key}` : key;
